import { Injectable } from '@angular/core';
import { UtService } from './Base.Service';
import { GenEnum } from "../../shell/shared/general.enum";

@Injectable()
export class MenusService extends UtService<any>{

    constructor() {
        super('utmenu');
    }

    async GetMenus(appcode) {
        const rslt = await this.get('MenusV2', appcode);
        return rslt.Data;
    }
    async getMenu() {
        const result = await this.get('menu', ['null', GenEnum.Menucategory.Screens]);
        return result
    }
}






// WEBPACK FOOTER //
// ./src/app/core/service/menus.service.ts